import { LegacyAmenities } from '@models/Amenities';
import { AmenitiesAndSurroundings } from '@models/AmenitiesAndSurroundings';
import { useRecoilValue, useResetRecoilState, useSetRecoilState } from 'recoil';
import {
    addressAtom,
    estimatedMarketValueAtom,
    googlePlaceIdAtom,
    homeQualityAtom,
    hasSkiInOutAtom,
    hasPrivateHotTubAtom,
    hasPrivatePoolAtom,
    hasCommunityHotTubAtom,
    hasCommunityPoolAtom,
    hasWaterfrontAtom,
    sleepsAtom,

    squareFootageAtom,
} from './atoms';
import { amenitiesSelector, surroundingsSelector } from './selectors';

function useAmenitiesValue() {
    return useRecoilValue(amenitiesSelector);
}

function useSetAmenitiesState() {
    const setHasPrivatePool = useSetRecoilState(hasPrivatePoolAtom);
    const setHasPrivateHotTub = useSetRecoilState(hasPrivateHotTubAtom);
    const setHasCommunityPool = useSetRecoilState(hasCommunityPoolAtom);
    const setHasCommunityHotTub = useSetRecoilState(hasCommunityHotTubAtom);
    const setHasWaterfront = useSetRecoilState(hasWaterfrontAtom);
    const setSkiInOut = useSetRecoilState(hasSkiInOutAtom);

    return (amenities: LegacyAmenities) => {
        setHasCommunityHotTub(amenities.has_community_hot_tub)
        setHasCommunityPool(amenities.has_community_pool)
        setHasPrivateHotTub(amenities.has_private_hot_tub)
        setHasPrivatePool(amenities.has_private_pool)
        setSkiInOut(amenities.has_ski_in_ski_out)
        setHasWaterfront(amenities.has_waterfront)
    };
}

function useResetAmenitiesState() {
    const resetHasPrivatePool = useResetRecoilState(hasPrivatePoolAtom);
    const resetHasPrivateHotTub = useResetRecoilState(hasPrivateHotTubAtom);
    const resetHasCommunityPool = useResetRecoilState(hasCommunityPoolAtom);
    const resetHasCommunityHotTub = useResetRecoilState(hasCommunityHotTubAtom);
    const resetHasWaterfront = useResetRecoilState(hasWaterfrontAtom);
    const resetHasSkiInSkiOut = useResetRecoilState(hasSkiInOutAtom);

    return () => {
        resetHasPrivatePool();
        resetHasPrivateHotTub();
        resetHasCommunityPool();
        resetHasCommunityHotTub();
        resetHasWaterfront();
        resetHasSkiInSkiOut();
    };
}

function useSurroundingsValue() {
    return useRecoilValue(surroundingsSelector);
}

// function useSetSurroundingsState() {

//     return (surroundings: LegacySurroundings) => {
//         setlake
//         lakefront: false,
//         hasOceanView: boolean;
//         oceanfront: boolean;
//         riverfront: boolean;
    
//     };
// }

// function useResetSurroundingsState() {

//     return () => {
//     };
// }

function useAmenitiesAndSurroundingsValue() {
    return { ...useAmenitiesValue(), ...useSurroundingsValue() };
}

function useSetAmenitiesAndSurroundingsState() {
    const setAmenities = useSetAmenitiesState();
    //const setSurroundings = useSetSurroundingsState();

    return (amenitiesAndSurroundings: AmenitiesAndSurroundings) => {
        setAmenities(amenitiesAndSurroundings);
        //setSurroundings(amenitiesAndSurroundings);
    };
}

export function useAmenitiesAndSurroundingsState(): [
    AmenitiesAndSurroundings,
    (amenitiesAndSurroundings: AmenitiesAndSurroundings) => void,
] {
    return [useAmenitiesAndSurroundingsValue(), useSetAmenitiesAndSurroundingsState()];
}

export function useResetState() {
    const resetAddress = useResetRecoilState(addressAtom);
    const resetGooglePlaceId = useResetRecoilState(googlePlaceIdAtom);

    const resetSleeps = useResetRecoilState(sleepsAtom);
    const resetSquareFootage = useResetRecoilState(squareFootageAtom);
    const resetEstimatedMarketValue = useResetRecoilState(estimatedMarketValueAtom) // prettier-ignore
    const resetHomeQuality = useResetRecoilState(homeQualityAtom);

    const resetAmenitiesState = useResetAmenitiesState();
    //const resetSurroundingsState = useResetSurroundingsState();

    return () => {
        resetAddress();
        resetGooglePlaceId();

        resetSleeps();
        resetSquareFootage();
        resetEstimatedMarketValue();
        resetHomeQuality();

        resetAmenitiesState();
        //resetSurroundingsState();
    };
}
